import "./jquery-global";

import "./layout/menu";
import "./activities";
import "./products-accordion";
import { initProductFilter } from "./products";
import "./sliders";

// Map functionality
import './map';
import 'slick-carousel';

// Initialize product filter
$(document).ready(() => {
    initProductFilter();
});